<form [formGroup]="reiskostenEigenZorg">

    <div formArrayName="pgaReiskostenEigenZorg">
        <div *ngFor="let item of pgaReiskostenEigenZorg.controls; let i = index; "
             [formGroupName]="i" class="row">

            <snelstart-ui-number-form-control (change)="saveForm()"
                                              [decimals]="0"
                                              [label]="i === 0 ? 'Aantal km' : ''"
                                              class="col-auto custom-input-125"
                                              formControlName="aantalKilometersNaartArtsZiekenhuis"
                                              id="aantalKilometersNaartArtsZiekenhuis"
            >
            </snelstart-ui-number-form-control>
            <snelstart-ui-number-form-control (change)="saveForm()"
                                              [decimals]="0"
                                              [label]="i === 0 ? 'Km-prijs (in centen)' : ''"
                                              align="right"
                                              class="col-auto custom-input-150"
                                              formControlName="prijsPerKilometerInCenten"
                                              [disabledControl]="this.aangifte.aangifteJaar > 2024"
                                              [placeholder]="this.aangifte.aangifteJaar > 2024 ? '23' : ''"
                                              id="prijsPerKilometerInCenten"
            >
            </snelstart-ui-number-form-control>
            <snelstart-ui-number-form-control (change)="saveForm()"
                                              [decimals]="0"
                                              [label]="i === 0 ? 'Uitgaven OV en overig' : ''"
                                              align="right"
                                              class="col-auto custom-input-175"
                                              formControlName="uitgavenOpenbaarVervoerEnOverigVervoer"
                                              id="uitgavenOpenbaarVervoerEnOverigVervoer"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
            <snelstart-ui-number-form-control (change)="saveForm()"
                                              [decimals]="0"
                                              [label]="i === 0 ? 'Extra reiskosten ziekte' : ''"
                                              align="right"
                                              class="col-auto custom-input-175"
                                              formControlName="extraReisKostenZiekteInvaliditeit"
                                              id="extraReisKostenZiekteInvaliditeit"
                                              prefix="€"
                                              [placeholder]="this.incomeTaxEntity.year! > 2024?  'Zie toelichting' : ''"
            >
            </snelstart-ui-number-form-control>
            <snelstart-ui-button (click)="verwijderRijRieskostenEigenZorg(i)"
                                 [class]="i === 0 ? 'firstrowbutton col-auto ' : 'col-auto '"
                                 iconType="light"
                                 id="buttonDeleteKosten"
                                 icon="trash"
                                 size="medium"
                                 type="secondary"
            >
            </snelstart-ui-button>
        </div>
    </div>
</form>

<div *ngIf="pgaReiskostenEigenZorg.length === 0">
    <snelstart-ui-button (click)="addRijReiskostenEigenZorg()" class="snelstart-ui-button pb-3" icon="plus"
                         type="link">Reiskosten eigen zorg
    </snelstart-ui-button>
</div>
<div *ngIf="pgaReiskostenEigenZorg.length > 0">
    <snelstart-ui-button (click)="addRijReiskostenEigenZorg()" class="snelstart-ui-button pb-3" icon="plus"
                         type="link">Reiskosten eigen zorg toevoegen
    </snelstart-ui-button>
</div>



